import React, { useContext, useEffect, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import MealCalendar from "./MealCalendar";
import MealStatusLegend from "../MealStatusLegend";
import { AppContext } from "../../AppContextProvider";
import { Role } from "../../models/User";
import { useNavigate } from "react-router-dom";
import { CART_URL } from "../../MainAppPanel";
import SurveyDialog from "../survey/SurveyDialog";

const CalendarPage: React.FC = () => {
  const { user, shoppingCart, survey } = useContext(AppContext);
  const [checkoutDisabled, setCheckoutDisabled] = useState(true);


  const navigate = useNavigate();

  useEffect(() => {
    setCheckoutDisabled(!shoppingCart.items.length);
  }, [shoppingCart]);


  return (
    <Box
      pt={1}
      pb={1}
      sx={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      {user.role === Role.PARENT || user.role === Role.STAFF ? (
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap-reverse",
            alignItems: "center",
            justifyContent: "flex-end",
            columnGap: 1,
            pl: 2,
            pr: 2,
            pt: 1,
            pb: 1,
          }}
        >
          <Box flexGrow={1}>
            <Typography fontWeight="bold" mb={1}>
              Scheduled Meals
            </Typography>
            <MealStatusLegend></MealStatusLegend>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: 2,
            }}
          >
            {user.availableCredits > 0 && (
              <Typography variant="body2" color="text.secondary">
                Available Credits: ${user.availableCredits.toFixed(2)}
              </Typography>
            )}
            <Button
              onClick={() => navigate(CART_URL)}
              disabled={checkoutDisabled}
              color="primary"
              size="small"
              variant="contained"
            >
              Checkout
            </Button>
          </Box>
        </Box>
      ) : (
        <></>
      )}

      <Box
        sx={{
          flexGrow: 1,
          overflowX: "auto",
          overflowY: "auto",
        }}
      >
        <Box
          sx={{
            pl: 2,
            pb: 2,
            pr: 2,
          }}
        >
          <MealCalendar/>
        </Box>
      </Box>
      {survey && <SurveyDialog onClose={() => {}} />}
    </Box>
  );
};

export default CalendarPage;
